import { Presenter } from '@shared/presenters/presenter';
import { humaniseDays } from '@shared/utils/humanise-days';
import type { Qualification } from './qualification';

export class QualificationPresenter extends Presenter<Qualification> {
    get name(): string {
        return this.data.name;
    }

    get courseLength() {
        return this._get('courseLength', () => {
            if (this.data.course_length_days) {
                return humaniseDays(this.data.course_length_days);
            }
        });
    }

    get expiresAfter() {
        return this._get('expiresAfter', () => {
            if (this.data.expires_after_days) {
                return humaniseDays(this.data.expires_after_days);
            }
        });
    }

    get qualificationClassName() {
        return this._get('qualification_class', () => {
            if (this.data.qualification_class?.data?.name) {
                this.data.qualification_class.data.name;
            }
        });
    }
}
